import React, { createContext, useContext } from 'react';
import { translations } from '@/lib/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const t = (key) => translations.en[key] || key;

  return <LanguageContext.Provider value={{ t }}>{children}</LanguageContext.Provider>;
};
